module.exports = __webpack_public_path__ + "img/google-maps.fda3f53b.png";